/**
 * Reusable field error message component
 * Displays error message in red text below form fields
 */
export default function FieldError({
  message,
  id,
}: {
  message?: string;
  id?: string;
}) {
  return message ? (
    <p id={id} className="text-sm text-red-500 mt-1" role="alert">
      {message}
    </p>
  ) : null;
}
